"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stimulus_1 = require("@hotwired/stimulus");
class default_1 extends stimulus_1.Controller {
    connect() { }
    _handleMenuSelect(event) {
        event.preventDefault();
        const target = event.target;
        this.inputTarget.value = target.dataset.locationId || "";
        console.log(target.dataset);
        this.inputTarget.dispatchEvent(new Event("change"));
        this.nameTarget.value = target.dataset.title || "";
        this.nameTarget.dispatchEvent(new Event("change"));
        this.triggerTarget.innerText = target.innerText || target.dataset.placeholder || "Choose Location";
        this.hideMenu(event);
    }
    showMenu(event) {
        this._log("showMenu:start");
        this.dialogTarget.addEventListener("location-menu:select", this._handleMenuSelect.bind(this));
        this.dialogController = this.application.getControllerForElementAndIdentifier(this.dialogTarget, "dialog");
        this.dialogPromise = this.dialogController.show();
        this._log("showMenu:end");
    }
    hideMenu(event) {
        var _a;
        this._log("hideMenu:start");
        this.dialogPromise = undefined;
        this.dialogTarget.removeEventListener("location-menu:select", this._handleMenuSelect.bind(this));
        (_a = this.dialogController) === null || _a === void 0 ? void 0 : _a.close();
        this._log("hideMenu:end");
    }
    _log(text) {
        console.log(this.identifier + ":" + text);
    }
}
exports.default = default_1;
default_1.targets = ["trigger", "dialog", "input", "name"];
default_1.values = {
    placeholder: String,
};
